import React, { Component } from 'react';
import MacroMapButton from './macros/MacroMapButton.js';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import RollEffectComponent from './RollEffectComponent.js';
import MacrosEffectComponent from './MacrosEffectComponent.js';
import PlayheadEffectComponent from './PlayheadEffectComponent.js';
import PaletteEffectComponent from './PaletteEffectComponent.js';
import {PALETTE_EFFECT, ROLL_EFFECT, MACROS_EFFECT, PLAYHEAD_EFFECT} from 'effects/live/constants.js';

class LiveEffectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getEffectChild() {
        switch (this.props.effect.effect) {
        case ROLL_EFFECT:
            return (
                <RollEffectComponent
                  {... this.props}/>
            );
        case MACROS_EFFECT:
            return (
                <MacrosEffectComponent
                  {... this.props}/>
            );
        case PALETTE_EFFECT:
            return (
                <PaletteEffectComponent
                  {... this.props}/>
            );
        case PLAYHEAD_EFFECT:
            return (
                <PlayheadEffectComponent
                  {... this.props}/>
            );
        default:
            return '';
        }
    }

    getMacroMapButton() {
        return (
            <MacroMapButton/>
        );
    }

    render() {
        return (
            <DeletableEffectComponent
              {...this.props}
              onDeleteEffect={this.props.onDeleteEffect}
              effectClass={this.props.effect.name}
              sequencerEngine={this.props.sequencerEngine}
              isLiveEffect={true}
              alternateButton={
                  this.props.effect.effect === MACROS_EFFECT ?
                      this.getMacroMapButton() :
                      undefined
              }
              effectNumber={this.props.effectNumber}
              onToggle={() => this.setState(this.state)}
              track={this.props.track}
              effect={this.props.effect}
              automation={this.props.automation}>
              {this.getEffectChild()}
            </DeletableEffectComponent>
        );
    }
}

export default LiveEffectComponent;
 
